import { ETextStyleVariant, GeneralAwardIcon, Text, Tooltip } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

interface IPartnerHostBadgeProps {
  className?: string;
  // Portal the tooltip so overflow-hidden map cards don't clip it.
  usePortal?: boolean;
  onMouseEnter?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

export const PartnerHostBadge = ({
  className,
  usePortal,
  onMouseEnter,
  onMouseLeave,
}: IPartnerHostBadgeProps) => {
  const intl = useIntl();
  return (
    <Tooltip
      content={intl.formatMessage({
        id: 'B9hQJT',
        defaultMessage:
          'Partner Hosts are professional rental businesses in a national operator network. They keep every license and insurance policy a commercial rental requires, and they complete regular industry training.',
        description: 'Partner Host badge tooltip on listing tile',
      })}
      className={className}
      usePortal={usePortal}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <span className="inline-flex items-center bg-green-100 px-1.5 py-0.5 rounded-md gap-1">
        <GeneralAwardIcon width={12} height={12} className="text-green-800" />
        <Text
          component="span"
          className="text-green-800 whitespace-nowrap"
          variant={ETextStyleVariant.LegalBold}>
          {intl.formatMessage({
            id: 't2zKga',
            defaultMessage: 'Partner Host',
            description: 'Listing header > partner program badge',
          })}
        </Text>
      </span>
    </Tooltip>
  );
};
